import { authBinaryFetch, authFetch } from "utils";
import { createUrlParams } from "utils/urlParams";

export const get = (id) =>
  authFetch(`${apiUrl}${version}/asset_leads/${id}`, {
    method: "GET",
  });

export const getAll = (portfolioIDs, status) => {
  const statusParam = status === "all" ? undefined : status;
  const urlParams = createUrlParams({
    portfolio_ids: portfolioIDs,
    status: statusParam,
  });

  return authFetch(`${apiUrl}${version}/asset_leads${urlParams}`, {
    method: "GET",
  });
};

export const update = (assetLead) =>
  authFetch(`${apiUrl}${version}/asset_leads/${assetLead.id}`, {
    method: "PATCH",
    json: { assetLead },
  });

export const destroy = (assetLeadID) =>
  authFetch(`${apiUrl}${version}/asset_leads/${assetLeadID}`, {
    method: "DELETE",
  });

export const create = (assetLead) =>
  authFetch(`${apiUrl}${version}/asset_leads`, {
    method: "POST",
    json: assetLead,
  });

export const exportXls = (portfolioIDs) => {
  const url = `${apiUrl}${version}/asset_leads/export/xls${createUrlParams({
    portfolio_ids: portfolioIDs,
  })}`;

  return authBinaryFetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
  });
};
